import { login, logout, loginWithToken } from '../api/authApi';
import { 
  setToken, 
  setUserRole, 
  setUserMasterId, 
  getToken, 
  getUserMasterId,
  isAdmin, 
  isUser 
} from '../utils/auth';

const authService = {
  async login(email, password) {
    try {
      const response = await login(email, password);
      // console.log('API Response:', response.data);

      const { token, roles, id, type, username, userid } = response.data; 
      if (!token || !roles || !id || !userid) {
        throw new Error('Invalid response from server');
      }

      
      setToken(token);
      setUserRole(Array.isArray(roles) ? roles[0].toLowerCase() : roles.toLowerCase());
      setUserMasterId(id.toString());
      localStorage.setItem('user_type', type);
      localStorage.setItem('username', username);
      localStorage.setItem('user_email', email);
      localStorage.setItem('userId', userid);  

      // console.log('Stored userId (email) in localStorage:', userid);

      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        throw new Error('Your Email or password is wrong. Please Try Again');
      }
  
      if (error.response && error.response.status === 500) {
        throw new Error('Your Email or password is wrong. Please Try Again');
      }
      throw error;
    }
  },

  async logout() {
    try {
      await logout();
    } catch (error) {
      // console.error('Logout error:', error);
    } finally {
      this.clearAllUserData();
    }
  },

  clearAllUserData() {
    sessionStorage.removeItem('auth_token');
    localStorage.removeItem('user_role');
    localStorage.removeItem('user_master_id');
    localStorage.removeItem('user_type');
    localStorage.removeItem('username');
    localStorage.removeItem('user_email');
    localStorage.removeItem('userId');  
    // localStorage.removeItem('bannerShown');
  },

  isAuthenticated() {
    const token = getToken(); 
    return !!token; 
  },

  getUserMasterId() {
    return getUserMasterId();
  },

  getUsername() {
    return localStorage.getItem('username');
  },

  getUserType() {
    return localStorage.getItem('user_type');
  },

  getUserEmail() {
    return localStorage.getItem('user_email') || '';
  },

  getUserId() { 
    return localStorage.getItem('userId');
  },

  isAdmin,
  isUser,
// -----------------------------------Start Add new code for token handler -----------------------------------
  async loginWithToken(token) {
    try {
      const response = await loginWithToken(token);
      const { token: newToken, roles, id, type, username, userid } = response.data;
      
      if (!newToken || !roles || !id || !userid) {
        throw new Error('Invalid response from server');
      }

      setToken(newToken);
      setUserRole(Array.isArray(roles) ? roles[0].toLowerCase() : roles.toLowerCase());
      setUserMasterId(id.toString());
      localStorage.setItem('user_type', type);
      localStorage.setItem('username', username);
      localStorage.setItem('user_email', userid);
      localStorage.setItem('userId', userid);

      return response.data;
    } catch (error) {
      throw error;
    }
  },
};
// -----------------------------------End Add new code for token handler -----------------------------------

export default authService;
